import styled from 'styled-components';
import {
  useLeaderboardFiltersModalActions,
  useLeaderboardFiltersModalView,
} from '@paradigm/features/src/leaderboard/contexts/filters/modal';

import { blackPearl_6 } from '@paradigm/design-system/src/colors';
import Button from '@paradigm/design-system/src/components/Button';
import HeadedModal from '@paradigm/design-system/src/components/HeadedModal';
import FilterForm, { FilterFormProps } from './FilterForm';

export default function LeaderboardFiltersModal({
  actions,
  state,
  hasStrategyField,
  filterType,
  lastUpdatedAt,
}: FilterFormProps) {
  const { isOpen } = useLeaderboardFiltersModalView();
  const { close } = useLeaderboardFiltersModalActions();
  const { reset } = actions;

  const handleSubmit = () => {
    close();
  };
  const handleReset = () => {
    reset();
    close();
  };

  return (
    <LeaderboardModal
      width={662}
      isOpen={isOpen}
      close={close}
      title="Filters"
      aria-label="leaderboard filters modal"
      theme="primary-dark"
      titleCss="font-weight: normal;"
      footerCss={`background-color: ${blackPearl_6};`}
      footerContent={
        <>
          <ClearButton ariaLabel="clear all filters" onClick={handleReset}>
            Clear All
          </ClearButton>
          <FilterButton
            type="submit"
            ariaLabel="submit filter"
            onClick={handleSubmit}
          >
            Filter
          </FilterButton>
        </>
      }
    >
      <FilterForm
        lastUpdatedAt={lastUpdatedAt}
        actions={actions}
        state={state}
        hasStrategyField={hasStrategyField}
        filterType={filterType}
      />
    </LeaderboardModal>
  );
}

const LeaderboardModal = styled(HeadedModal)`
  .modal-content {
    background: ${blackPearl_6};
  }
`;

const ClearButton = styled(Button).attrs({ variant: 'link', size: 'large' })`
  text-align: left;
`;

const FilterButton = styled(Button).attrs({ size: 'large' })`
  flex: 0;
  min-width: 120px;
  margin-left: auto;
`;
